import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChangeMobile } from '../action-creators';
import {
  isMobile,
  isSmallScreen,
  isLaptop,
  isTablet,
} from '@components/styles';

const resize$ = fromEvent(window, 'resize');

export const handleResizeEpic = () =>
  resize$.pipe(
    map(
      () =>
        new ChangeMobile(isMobile(), isSmallScreen(), isLaptop(), isTablet())
    )
  );
